import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=07a439c8"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a439c8')) {
      api.createRecord('07a439c8', component.options)
    } else {
      api.reload('07a439c8', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=07a439c8", function () {
      api.rerender('07a439c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/Logs.vue"
export default component.exports